(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    if (!window.cultureHouseInlineFiltersInitialized) {
    window.cultureHouseInlineFiltersInitialized = true;
    const openSections = new Set();

    const getSectionId = (collectionComponent) =>
      collectionComponent?.querySelector('results-list[section-id]')?.getAttribute('section-id');

    const setInlineFiltersOpen = (collectionComponent, isOpen, restoreFocus = false) => {
      if (!collectionComponent) return;

      collectionComponent.toggleAttribute('data-filters-open', isOpen);
      const inlinePanel = collectionComponent.querySelector('.culture-house-inline-filters');
      inlinePanel?.setAttribute('aria-hidden', String(!isOpen));
      const trigger = collectionComponent.querySelector('[data-culture-house-filter-trigger]');
      trigger?.setAttribute('aria-expanded', String(isOpen));

      const sectionId = getSectionId(collectionComponent);
      if (sectionId) {
        if (isOpen) openSections.add(sectionId);
        else openSections.delete(sectionId);
      }

      if (!isOpen && restoreFocus) trigger?.focus();
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const trigger = event.target.closest('[data-culture-house-filter-trigger]');
      const close = event.target.closest('[data-culture-house-filter-close]');
      if (!trigger && !close) return;

      const control = trigger || close;
      const collectionComponent = control.closest('collection-component');
      setInlineFiltersOpen(
        collectionComponent,
        trigger ? !collectionComponent?.hasAttribute('data-filters-open') : false,
        Boolean(close)
      );
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('collection-component[data-filters-open]').forEach((collectionComponent) => {
        setInlineFiltersOpen(collectionComponent, false, true);
      });
    });

    document.addEventListener('shopify:collection:update', (event) => {
      const collectionComponent = event.target instanceof Element ? event.target.closest('collection-component') : null;
      const sectionId = getSectionId(collectionComponent);
      if (!sectionId || !collectionComponent?.hasAttribute('data-filters-open')) return;

      openSections.add(sectionId);
      Promise.resolve(event.promise).then(() => {
        if (!openSections.has(sectionId)) return;

        requestAnimationFrame(() => {
          const resultsList = document.querySelector(`results-list[section-id="${CSS.escape(sectionId)}"]`);
          setInlineFiltersOpen(resultsList?.closest('collection-component'), true);
        });
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
